import React from 'react';
import { Panel } from './BundleCard';

const PanelList = ({ title, panels, selectionType, onSelect, selections }) => {
	const disabled = !onSelect;

	const handleSelect = (id) => {
		onSelect(id);
	};

	const toggleRadioKeyDown = (evt, panelId) => {
		// Space = toggle
		if (evt.key === ' ') {
			evt.preventDefault();
			onSelect(panelId);
		}
	};

	return (
		<div className="card mb-3">
			{!!title && (
				<div className="card-header ">
					<h5 className="m-0 bold fs-6">{title}</h5>
				</div>
			)}

			<ul className="list-group list-group-flush">
				{panels.map((panel) => {
					const inputId = `alcat-panel-${panel.id}`;
					const selected = selections?.some((detail) => detail?.id === panel.id);
					const parentSelected = selections?.find((detail) =>
						detail?.panels?.some((childPanel) => childPanel?.id === panel.id)
					);
					// Change the radio group name when a parent is selected so the disabled child selection doesn't interfere with the parent radio selection
					let inputName = selectionType === 'radio' ? 'ALCATPanels' : undefined;
					if (selectionType === 'radio' && parentSelected) {
						inputName = `ALCATPanels-${parentSelected.id}`;
					}
					return (
						<li
							key={panel.id}
							className="list-group-item alcat-bundle"
							title={parentSelected ? `Component of ${parentSelected.title}` : ''}
						>
							<div className="form-check d-flex gap-3 align-items-center">
								<input
									className="form-check-input flex-shrink-0 my-0"
									type={selectionType === 'radio' ? 'radio' : 'checkbox'}
									name={inputName}
									id={inputId}
									value={panel.id}
									checked={selected || !!parentSelected}
									onClick={() => handleSelect(panel.id)}
									onKeyDown={(evt) => toggleRadioKeyDown(evt, panel.id)}
									readOnly
									disabled={disabled || !!parentSelected}
								/>
								<label
									className="m-0 stretched-link cursor-pointer text-reset fw-normal flex-grow-1"
									htmlFor={inputId}
								>
									<Panel {...panel} alignItems="center" />
								</label>
							</div>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default PanelList;
